import { DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { EditOption } from "../../../../models/edit-option.model";
import { Flight } from "../../../../models/flight.model";
import { id } from "../../../form/controls";
import { FlightEditLookups, TEXT_ONLY_ID } from "../../../form/flight-edit-lookups";

/** The pilot and the copilot of the flight, each with a role. */
export function pilotsControls(flight: Flight, lookups: FlightEditLookups) {
    return {
        pilotId: new FormControl<number | null>(flight.pilotId ?? (flight.pilot1Name?.trim() ? TEXT_ONLY_ID : null), Validators.required),
        pilotRoleId: new FormControl<number | null>(flight.pilotRoleId ?? lookups.roleIdOf(flight.pilot1Role), Validators.required),
        coPilot: new FormControl<EditOption | null>(lookups.coPilotOf(flight)),
        coPilotRoleId: id(flight.coPilotRoleId ?? lookups.roleIdOf(flight.pilot2Role)),
    };
}

/** As in the app: a copilot needs a role, and a copilot's role needs a copilot. */
export const coPilotWithRole: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const { coPilot, coPilotRoleId } = group.value as { coPilot: EditOption | null; coPilotRoleId: number | null };
    if (coPilot && coPilotRoleId === null) return { coPilotRole: true };
    if (!coPilot && coPilotRoleId !== null) return { coPilot: true };
    return null;
};

/** As in the app, clearing the copilot clears its role. */
export function watchCoPilot(coPilot: FormControl<EditOption | null>, role: FormControl<number | null>, destroyRef: DestroyRef): void {
    coPilot.valueChanges.pipe(takeUntilDestroyed(destroyRef)).subscribe((value) => {
        if (!value) role.setValue(null);
    });
}
